// extracted by css-extract-rspack-plugin
export default {"cls1":"useOverviewReadyToast-cls1_5sE","cls2":"useOverviewReadyToast-cls2_13c useOverviewReadyToast-cls1_5sE"};